export const PERSONAL_REGISTER = "PERSONAL_REGISTER";
export const CORPORATE_REGISTER = "CORPORATE_REGISTER";
export const LOGIN_WEBSITE_USER = "LOGIN_WEBSITE_USER";
export const FORGET_PASSWORD = "FORGET_PASSWORD";
export const RESET_PASSWORD = "RESET_PASSWORD";
export const LOGOUT = "LOGOUT";
